<template>
  <div class="menu" :class="{ 'menu--white': isWhiteMode }">
    <div class="menu__burger" @click="toggleMenu">
      <span class="menu__burger-label">Menu</span>
      <div class="menu__burger-lines">
        <div class="menu__burger-line"></div>
        <div class="menu__burger-line"></div>
        <div class="menu__burger-line"></div>
      </div>
    </div>
    <section class="menu-wrapper" :class="{ 'menu-wrapper--isOpen': isOpen }">
      <div class="menu-container container">
        <button class="menu__close-button" @click="toggleMenu"></button>
        <nav class="menu__nav">
          <ul class="menu__list" @click="checkRedirect">
            <li class="menu__list-item">
              <router-link :to="{name: 'home'}" class="link menu__list-link" data-route="/">Home</router-link>
            </li>
            <li class="menu__list-item">
              <router-link :to="{name: 'about'}" class="link menu__list-link" data-route="/about">About</router-link>
            </li>
            <li class="menu__list-item">
              <router-link :to="{name: 'portfolio'}" class="link menu__list-link" data-route="/portfolio">Portfolio</router-link>
            </li>
            <li class="menu__list-item">
              <router-link :to="{name:'contact-us'}" class="link menu__list-link" data-route="/contact-us">Contacts</router-link>
            </li>
          </ul>
        </nav>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  props: {
    isOpen: {
      type: Boolean
    },
    isWhiteMode: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    checkRedirect(e) {
      const { target: { dataset: { route } } } = e;
      if (route === this.$route.path) {
        this.toggleMenu();
      }
    },
    toggleMenu() {
      this.$emit("toggleMenu");
    }
  },
};
</script>

